import { useState } from 'react';
import MultipleSelectBtns from 'components/common/elements/MultipleSelectBtns';
import Badge from 'components/common/elements/Badge';
import styles from 'styles/components/pages/professor/student/SearchFilter.module.scss';
import { ReactComponent as ResetIcon } from 'assets/icons/reset.svg';
import { STYLES_VARIABLES } from 'constants/styleVariables';

type TProps = {
  schoolYears: number[] | undefined;
  scores: string[] | undefined;
  onChange: (
    schoolYear: number[] | undefined,
    score: string[] | undefined
  ) => void;
};

const schoolYearList = [
  { label: '1학년', value: 1 },
  { label: '2학년', value: 2 },
  { label: '3학년', value: 3 },
];

const scoreList = [
  { label: '매우 우수', value: 'VERY_HIGH' },
  { label: '우수', value: 'HIGH' },
  { label: '보통', value: 'NORMAL' },
  { label: '낮음', value: 'LOW' },
  { label: '매우 낮음', value: 'VERY_LOW' },
];

const SearchFilter = ({ schoolYears, scores, onChange }: TProps) => {
  const [schoolYearStates, setSchoolYearStates] = useState(
    schoolYearList.map((_, index) =>
      schoolYears?.includes(schoolYearList[index].value) ? true : false
    )
  );
  const [scoreStates, setScoreStates] = useState(
    scoreList.map((_, index) =>
      scores?.includes(scoreList[index].value) ? true : false
    )
  );

  const onChangeBtn = (type: string, index: number) => {
    if (type === 'schoolYear') {
      const newSchoolYearStates = [...schoolYearStates];
      newSchoolYearStates[index] = !newSchoolYearStates[index];
      setSchoolYearStates(newSchoolYearStates);
      onChange(
        newSchoolYearStates
          .map((state, index) => (state ? schoolYearList[index].value : -1))
          .filter((value) => value !== -1),
        scores
      );
    } else if (type === 'score') {
      const newScoreStates = [...scoreStates];
      newScoreStates[index] = !newScoreStates[index];
      setScoreStates(newScoreStates);
      onChange(
        schoolYears,
        newScoreStates
          .map((state, index) => (state ? scoreList[index].value : ''))
          .filter((value) => value !== '')
      );
    }
  };

  const reset = () => {
    setSchoolYearStates(schoolYearList.map(() => false));
    setScoreStates(scoreList.map(() => false));
    onChange(undefined, undefined);
  };

  return (
    <div className={styles.filter}>
      <div className={styles.title_wrapper}>
        <h2 className={styles.filter_title}>검색 필터</h2>
        <span className={styles.caption}>* 복수 선택 가능</span>
      </div>
      <div className={styles.multi_select_wrapper}>
        <div className={styles.multi_select}>
          <label className={styles.label}>학년</label>
          <MultipleSelectBtns
            btnGroup={schoolYearList}
            btnStyles={{ width: '120px', height: '48px' }}
            btnStates={schoolYearStates}
            onChange={(index) => onChangeBtn('schoolYear', index)}
          />
        </div>
        <div className={styles.multi_select}>
          <label className={styles.label}>평가결과</label>
          <MultipleSelectBtns
            btnGroup={scoreList}
            btnStates={scoreStates}
            btnStyles={{ width: '120px', height: '48px' }}
            onChange={(index) => onChangeBtn('score', index)}
          />
        </div>
      </div>
      <div className="divider_line my24"></div>
      <div className="flex justify_between">
        <div>
          {schoolYears?.map((schoolYear) => (
            <Badge
              key={schoolYear}
              text={
                schoolYearList.find((data) => data.value === schoolYear)
                  ?.label || ''
              }
              onDelete={() =>
                onChangeBtn(
                  'schoolYear',
                  schoolYearList.findIndex((data) => data.value === schoolYear)
                )
              }
            />
          ))}
          {scores?.map((score) => (
            <Badge
              key={score}
              text={scoreList.find((data) => data.value === score)?.label || ''}
              onDelete={() =>
                onChangeBtn(
                  'score',
                  scoreList.findIndex((data) => data.value === score)
                )
              }
            />
          ))}
        </div>
        <div className="flex items_center">
          <button type="button" className={styles.reset_btn} onClick={reset}>
            <ResetIcon fill={STYLES_VARIABLES.GRAY_07} />
            <span className={styles.reset_text}>초기화</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;
